import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
// import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { Button } from 'antd';
import { getChildrenToRender } from './utils';

class Content115 extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isShow: this.props.isShow
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isShow !== this.props.show) {
      this.setState({isShow: this.props.isShow});
    }
  }

  componentDidMount() {
    this.setState({
      isShow: this.props.isShow
    })
  }

  render() {
    
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    if (this.state.isShow === 2) {
      return null;
    }else return (
      <OverPack {...props} {...dataSource.OverPack}>
        <div {...dataSource.titleWrapper}>{dataSource.titleWrapper.children.map(getChildrenToRender)}</div>
        <TweenOne
          key="button"
          style={{ textAlign: 'center' }}
          {...dataSource.button}
          animation={{ y: 30, opacity: 0, type: 'from', delay: 300 }}
        >
          <Button {...dataSource.button.children.a}>
            {dataSource.button.children.a.children}
          </Button>
        </TweenOne>
      </OverPack>
    );
  }
}

export default Content115;
